import React, { useState } from "react";
import styles from "./CreateForm.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import { FiFileText } from "react-icons/fi";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";
import RadioComponent from "../../components/RadioComponent/RadioComponent";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import { closeModal } from "../../redux/slices/modalSlice"; // Adjust path as needed
import { useDispatch } from "react-redux";

const CreateForm = () => {
  // --- Form Details ---
  const [formName, setFormName] = useState("");
  const [formStatus, setFormStatus] = useState("");
  const [sendEmail, setSendEmail] = useState("Yes");
  const [notificationTo, setNotificationTo] = useState("");
  const [formDisplayName, setFormDisplayName] = useState("");
  const [enquiryStatus, setEnquiryStatus] = useState("");
  const [navigateTo, setNavigateTo] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const [htmlHeader1, setHtmlHeader1] = useState("");
  const [htmlHeader2, setHtmlHeader2] = useState("");

  // --- Child Info ---
  const [studentName, setStudentName] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("Male");
  const [address, setAddress] = useState("");
  const [emergencyName, setEmergencyName] = useState("");
  const [emergencyNumber, setEmergencyNumber] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");
  const [allergies, setAllergies] = useState("");
  const [medication, setMedication] = useState("");

  const handleSave = () => {
    const formData = {
      formName,
      formStatus,
      sendEmail,
      notificationTo,
      formDisplayName,
      enquiryStatus,
      navigateTo,
      redirectURL,
      htmlHeader1,
      htmlHeader2,
      studentName,
      dob,
      gender,
      address,
      emergencyName,
      emergencyNumber,
      bloodGroup,
      allergies,
      medication,
    };

    console.log("Submitting form:", formData);
  };
  const dispatch=useDispatch();

   const handleClose = () => {
      console.log("Cancelled Deletion");
      dispatch(closeModal());
    };
  

  return (
    <div className={styles.container}>
      {/* FORM DETAILS */}
      <div className={styles.modalCard}>
        <div className={styles.header}>
          <HeadingAndIcon icon={<FiFileText />} heading="Form Details" />
          <ToClose onClose={handleClose} />
        </div>

        <div className={styles.datacardContent}>
          <div className={styles.row}>
            <HeadingAndData
              label="Form Name"
              value={formName}
              placeholder="Enter form name"
              onChange={(e) => setFormName(e.target.value)}
              required
            />
            <HeadingAndDropDown
              label="Form Status"
              value={formStatus}
              placeholder="Select an option"
              onChange={(e) => setFormStatus(e.target.value)}
              options={[
                { label: "Active", value: "active" },
                { label: "Inactive", value: "inactive" },
              ]}
              required
            />
            <div className={styles.inputBlock}>
              <label className={styles.inputLabel}>
                Send email after enquiry creation
              </label>
              <div className={styles.radioOptions}>
                <RadioComponent
                  name="sendEmail"
                  value="Yes"
                  label="Yes"
                  checked={sendEmail === "Yes"}
                  onChange={(e) => setSendEmail(e.target.value)}
                />
                <RadioComponent
                  name="sendEmail"
                  value="No"
                  label="No"
                  checked={sendEmail === "No"}
                  onChange={(e) => setSendEmail(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className={styles.row}>
            <HeadingAndDropDown
              label="Send notification to"
              value={notificationTo}
              placeholder="Select staff"
              onChange={(e) => setNotificationTo(e.target.value)}
              options={[
                { label: "Staff A", value: "a" },
                { label: "Staff B", value: "b" },
              ]}
              required
            />
            <HeadingAndData
              label="Form display name"
              placeholder="Enter name"
              value={formDisplayName}
              onChange={(e) => setFormDisplayName(e.target.value)}
              required
            />
            <HeadingAndDropDown
              label="Status of the enquiry after creation"
              value={enquiryStatus}
              placeholder="Choose status"
              onChange={(e) => setEnquiryStatus(e.target.value)}
              options={[
                { label: "New", value: "new" },
                { label: "In Progress", value: "progress" },
              ]}
              required
            />
          </div>

          <HeadingAndData
            label="Navigate to"
            value={navigateTo}
            placeholder="Enter URL"
            onChange={(e) => setNavigateTo(e.target.value)}
            required
          />
          <HeadingAndData
            label="Set web page address to navigate to after submission"
            value={redirectURL}
            placeholder="Enter redirect URL"
            onChange={(e) => setRedirectURL(e.target.value)}
            required
          />
          <div className={styles.inputBlock}>
            <label className={styles.inputLabel}>
              HTML to be embed in header
            </label>
            <textarea
              className={styles.fixedTextarea}
              value={htmlHeader1}
              onChange={(e) => setHtmlHeader1(e.target.value)}
              placeholder="Enter HTML content..."
            ></textarea>
          </div>

          <div className={styles.inputBlock}>
            <label className={styles.inputLabel}>
              HTML to be embed in header
            </label>
            <textarea
              className={styles.fixedTextarea}
              value={htmlHeader2}
              onChange={(e) => setHtmlHeader2(e.target.value)}
              placeholder="Enter HTML content..."
            ></textarea>
          </div>

          <div className={styles.actionsRow}>
            <SaveAndCancel
              onCancel={() => console.log("Cancel")}
              onSave={handleSave}
            />
          </div>
        </div>
      </div>

      {/* CHILD INFO */}
      <div className={styles.modalCard}>
        <div className={styles.header}>
          <HeadingAndIcon icon={<FiFileText />} heading="Child Information" />
        </div>
        <div className={styles.datacardContent}>
        <div className={styles.row}>
          <HeadingAndData
            label="Student Name"
            value={studentName}
            placeholder="Enter student name"
            onChange={(e) => setStudentName(e.target.value)}
            required
          />
          <CalendarInput
            fieldLabel="Date of Birth"
            value={dob}
            onChange={setDob}
            label="Choose date"
            required
          />
          <div className={styles.inputBlock}>
            <label className={styles.inputLabel}>Gender *</label>
            <div className={styles.radioOptions}>
              <RadioComponent
                name="gender"
                value="Male"
                label="Male"
                checked={gender === "Male"}
                onChange={(e) => setGender(e.target.value)}
              />
              <RadioComponent
                name="gender"
                value="Female"
                label="Female"
                checked={gender === "Female"}
                onChange={(e) => setGender(e.target.value)}
              />
            </div>
          </div>
        </div>

        <HeadingAndData
          label="Address"
          value={address}
          placeholder="Enter your address"
          onChange={(e) => setAddress(e.target.value)}
          required
        />

        <div className={styles.row}>
          <HeadingAndData
            label="Emergency contact name"
            value={emergencyName}
            placeholder="Enter name"
            onChange={(e) => setEmergencyName(e.target.value)}
            required
          />
          <HeadingAndData
            label="Emergency contact no"
            value={emergencyNumber}
            placeholder="Enter contact number"
            onChange={(e) => setEmergencyNumber(e.target.value)}
            required
          />
          <HeadingAndDropDown
            label="Blood group"
            value={bloodGroup}
            placeholder="Select blood group"
            onChange={(e) => setBloodGroup(e.target.value)}
            options={[
              { label: "A+", value: "a+" },
              { label: "B+", value: "b+" },
              { label: "O+", value: "o+" },
            ]}
            required
          />
        </div>

        <div className={styles.row}>
          <HeadingAndData
            label="Allergies"
            value={allergies}
            placeholder="Mention allergies if any"
            onChange={(e) => setAllergies(e.target.value)}
            required
          />
          <HeadingAndData
            label="Medication"
            value={medication}
            placeholder="Mention allergies if any"
            onChange={(e) => setMedication(e.target.value)}
            required
          />
        </div>

        <div className={styles.actionsRow}>
          <SaveAndCancel
            onCancel={() => console.log("Cancel")}
            onSave={handleSave}
          />
        </div>
      </div>
      </div>
    </div>
  );
};

export default CreateForm;
